import { Switch, Select, Slider, Typography, Space, Divider } from 'antd';
import useSceneStore from '../../stores/sceneStore';

const { Text } = Typography;

export default function ClippingPanel() {
  const { clipping, setClipping } = useSceneStore();

  return (
    <div style={{ padding: 12 }}>
      <Text strong style={{ fontSize: 13 }}>剖面切割</Text>
      <Divider style={{ margin: '8px 0' }} />

      <Space orientation="vertical" style={{ width: '100%' }} size="middle">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Text style={{ fontSize: 12, color: '#888' }}>启用切割</Text>
          <Switch size="small" checked={clipping.enabled}
            onChange={(v) => setClipping({ enabled: v })} />
        </div>

        {clipping.enabled && (
          <>
            <div>
              <Text style={{ fontSize: 12, color: '#888' }}>切割轴</Text>
              <Select
                size="small"
                style={{ width: '100%', marginTop: 4 }}
                value={clipping.axis}
                onChange={(v) => setClipping({ axis: v })}
                options={[
                  { value: 'x', label: 'X 轴' },
                  { value: 'y', label: 'Y 轴' },
                  { value: 'z', label: 'Z 轴' },
                ]}
              />
            </div>
            <div>
              <Text style={{ fontSize: 11, color: '#999' }}>位置: {clipping.position.toFixed(1)}</Text>
              <Slider min={-10} max={10} step={0.1} value={clipping.position}
                onChange={(v) => setClipping({ position: v })} />
            </div>
          </>
        )}
      </Space>
    </div>
  );
}
